const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTadaSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 50.8 50.8",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M53.036 76.955c-.017-.018-1.302.835-2.854 1.895-2.824 1.928-2.824 1.928-3.603 1.948-.58.014-1.01.1-1.683.335-.498.175-1.144.457-1.436.629-.407.239-.755.536-1.493 1.275-.86.859-1.013 1.049-1.429 1.761-.256.44-.696 1.27-.978 1.845-.283.576-.521 1.043-.531 1.039-.01-.005-.286-.046-.614-.092s-1.07-.075-1.65-.065c-.58.011-1.392.091-1.807.178-.415.087-.96.252-1.21.366-.25.114-.59.342-.755.507-.165.166-.354.431-.419.59-.065.159-.093.373-.062.476.03.102.246.376.477.607.273.273.733.605 1.304.942a19.02 19.02 0 0 0 1.736.89c.47.203.955.399 1.079.434.2.057.233.103.293.416.045.238.153.438.331.617.146.145.407.323.58.394.175.071.427.133.562.137.245.008.245.008.602 1.025a20.3 20.3 0 0 0 .798 1.9c.279.562.588 1.054.846 1.35.292.333.457.469.585.48a.865.865 0 0 0 .351-.056c.095-.04.326-.222.513-.405.191-.188.44-.538.57-.803a7.65 7.65 0 0 0 .394-1.054c.09-.32.22-1.01.286-1.53.067-.522.108-1.413.092-1.981-.029-1.033-.028-1.033.806-1.542.458-.28 1.2-.766 1.647-1.08.447-.314 1.14-.867 1.54-1.229.436-.394.879-.866 1.106-1.178.209-.286.502-.772.65-1.08.15-.308.318-.79.375-1.073.057-.283.103-.752.104-1.044 0-.291-.04-.71-.088-.932-.049-.221-.046-.423.006-.45.053-.026.752-1.479 1.553-3.228.802-1.75 1.444-3.196 1.426-3.214z",
    className: "UnoptimicedTransforms",
    style: {
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 1.78946,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(1.77213 .01656 -.01653 1.77628 -50.28 -131.288)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTadaSvg);
export default __webpack_public_path__ + "static/media/tada-svg.c7696a3ceb089e435be8ebb71e86eae8.svg";
export { ForwardRef as ReactComponent };